"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadDefaults = exports.clone = void 0;
function clone(val) {
    if (Array.isArray(val)) {
        return [...val];
    }
    else if (typeof val === "object") {
        return Object.assign({}, val);
    }
    else {
        return val;
    }
}
exports.clone = clone;
function loadDefaults(args, defaults) {
    return Object.assign(defaults, args);
}
exports.loadDefaults = loadDefaults;
//# sourceMappingURL=utils.js.map